




import IFloorPlanDto from "./FloorPlanDto.if";
import mappings from "./FloorPlanDto.map";
import IMediumDto from "./MediumDto.if";
import MediumDto from "./MediumDto";
import ISiteDto from "./SiteDto.if";
import SiteDto from "./SiteDto";
import IStyleDto from "./StyleDto.if";
import StyleDto from "./StyleDto";

import { IModelSource } from "./private/db.if";
import Transformers from './private/transformer';
import DBUtil from './private/db.util';
import ISiteObjectOnFloorPlanDto from "./SiteObjectOnFloorPlanDto.if";
import SiteObjectOnFloorPlanDto from "./SiteObjectOnFloorPlanDto";
import ISiteObjectDto from "./SiteObjectDto.if";

function _image(this: IFloorPlanDto, db: IModelSource): Promise<IMediumDto> {
    return DBUtil.loadMediumId<IMediumDto>(db, this.imageMediumId, MediumDto);
}

function _site(this: IFloorPlanDto, db: IModelSource): Promise<ISiteDto> {
    return DBUtil.loadSiteId<ISiteDto>(db, this.siteId, SiteDto);
}

function _style(this: IFloorPlanDto, db: IModelSource): Promise<IStyleDto> {
    return DBUtil.loadStyleId<IStyleDto>(db, this.styleId, StyleDto);
}

function _allSiteObjectsOnFloorplan(this: IFloorPlanDto, db: IModelSource): Promise<ISiteObjectOnFloorPlanDto[]> {
    const _that = this;
    return new Promise(function(resolve, reject) {
        DBUtil.allSiteObjectOnFloorplan<ISiteObjectOnFloorPlanDto>(db, SiteObjectOnFloorPlanDto)
            .then((soFPs) => {
                const match = soFPs.filter(x => x.floorPlanId === _that.id);
                if ( match.length > 0 ) {
                    resolve(match)
                } else {
                    reject('No SiteObjectOnFloorplans found for floorplanId:'+_that.id);
                }
            })
            .catch(error => reject(error));
    });
};

function _siteObjectOnFloorplan(this: IFloorPlanDto, siteObject: ISiteObjectDto, db: IModelSource): Promise<ISiteObjectOnFloorPlanDto> {
    const _that = this;
    return new Promise(function(resolve, reject) {
        _that.allSiteObjectsOnFloorplan(db)
            .then(soFPs => {
                const match = soFPs.filter(x => x.siteObjectId === siteObject.id);
                if ( match.length > 0 ) {
                    resolve(match[0])
                } else {
                    reject(`No matching soFPs found for floorplanId ${_that.id}/siteObjectId: ${siteObject.id}`);
                }
            })
            .catch(error => reject(error));
    });
};

export default (data: object) => { 
    const obj = Transformers.create<IFloorPlanDto>(mappings, data); 

    /* addLinkables */
    obj.image = _image;
    obj.site = _site;
    obj.style = _style;

    obj.allSiteObjectsOnFloorplan = _allSiteObjectsOnFloorplan;
    obj.siteObjectOnFloorplan = _siteObjectOnFloorplan;

    return obj;
}

